const PeriodicidadOptions = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'Diario (03)',
    value: '03',
  },
  {
    label: 'Semanal (01)',
    value: '01',
  },
  {
    label: 'Quincenal (04)',
    value: '04',
  },
  {
    label: 'Mensual (02)',
    value: '02',
  },
  {
    label: 'Otro (05)',
    value: '05',
  },
];

export default PeriodicidadOptions;
